import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class GroupeSelect extends React.Component {
    render() {
        const { value, onChange, groupes, all, excluded, isRequired, error, disabled, label, size } = this.props;


        let selected = value;
        if (groupes.length === 0 || value === 0) {
            selected = '';
        }


        return (<TextField
            select
            name="groupeId"
            label={label}
            size={size}
            value={selected}
            onChange={onChange}
            required={isRequired}
            error={error !== undefined}
            fullWidth
            disabled={disabled}
        >

            {all === true ? <MenuItem key={0} value={0}><em>Tous</em></MenuItem> : null}

            {groupes.map(groupe => (

                (excluded === null || excluded !== groupe.id) &&

                    (<MenuItem key={groupe.id} value={groupe.id}>
                        {groupe.libelle}
                    </MenuItem>)
            ))}

        </TextField>
        );
    }
}

GroupeSelect.defaultProps = {
    label:'Groupe',
};

GroupeSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    all: PropTypes.bool.isRequired,
    excluded: PropTypes.number,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,

    groupes: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    label: PropTypes.string,
    size: PropTypes.string

};

export default GroupeSelect;